import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SvgPlayFilled } from '../../../../icons';
import { SingleRecording } from '../../../../queries/ats/recordings/types/recording';
import { isBookmarkedRecording } from '../../../../queries/ats/recordings/utils/bookmarked-recording';
import { routes } from '../../../../routes/route-utils';
import { localizedRelativeTime } from '../../../../utils/ats-details-utils';
import { FocusedAsset } from '../../use-focused-asset';
import { appendSequenceNumbers } from '../../utils';
import { CallToAction } from '../call-to-action-button';
import { RecordedContinueWatchingButton } from '../continue-watching-button';

interface RecordedCallToActionProps {
  focusedAsset: FocusedAsset;
  recording: SingleRecording;
  image: string;
}

export function RecordedCallToAction({ focusedAsset, recording, image }: RecordedCallToActionProps) {
  const { t } = useTranslation();

  const recordedAt = moment(recording.startTime);
  const recordedPreviousYear = recordedAt.isBefore(moment().startOf('year'));
  const url = routes.recording(recording);

  if (isBookmarkedRecording(recording)) {
    return <RecordedContinueWatchingButton focusedAsset={focusedAsset} recording={recording} image={image} />;
  }

  return (
    <CallToAction
      text={{
        primary: appendSequenceNumbers(t('details:watch-now'), focusedAsset),
        secondary: recordedPreviousYear
          ? recordedAt.format('DD MMM YYYY')
          : localizedRelativeTime(recording.startTime, 'recording'),
      }}
      image={{
        src: image,
        alt: recording.channelName,
      }}
      icon={<SvgPlayFilled />}
      to={url.pathname}
    />
  );
}
